export default (): string | null => {
  return sessionStorage.getItem("@LockytEnterprise:token");
};
